import { Injectable } from '@angular/core';
import { LanguageService } from '@core/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
	LANGUAGE_CHANGE,
  LANGUAGE_FIND,
  LANGUAGE_FIND_SUCCESS,
  LANGUAGE_UPDATE_LOADING,
  SERVICE_FAILURE,
} from '@store/actions';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class LanguageEffects {
  constructor(
    private actions$: Actions,
		private store: Store,
    private languageService: LanguageService
  ) {}

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LANGUAGE_FIND),
      mergeMap(({ language }) => {
        this.store.dispatch(LANGUAGE_UPDATE_LOADING({ loading: true }));

        return this.languageService.find(language).pipe(
          mergeMap((data) => {
            return [
              LANGUAGE_UPDATE_LOADING({ loading: false }),
              LANGUAGE_FIND_SUCCESS({ language, translations: data }),
            ];
          }),
          catchError((error) =>
            of(error).pipe(
              mergeMap((error) => {
                return [
                  SERVICE_FAILURE({ error }),
                  LANGUAGE_UPDATE_LOADING({ loading: false }),
                ];
              })
            )
          )
        );
      })
    )
  );

  changeLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LANGUAGE_CHANGE),
      map(({ language }) => LANGUAGE_FIND({ language }))
    )
  );
}
